import { RCBanner, RCIcon, RCText } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import React from 'react';
import URLHelpers from '../shared/url_helpers';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import { WarningIcon } from '@reverbdotcom/cadence/icons/react';
import { useHelpCenterArticleUrl } from '@reverbdotcom/commons/src/url_helpers';
import I18n from 'i18n-js';

const FIRST_ALERT = 'first_alert';
const SECOND_ALERT = 'second_alert';
const THIRD_ALERT = 'third_alert';
const HELP_CENTER_ARTICLE_ID = '41988483251483';

export interface Props {
  alertLevel: string;
}

const bannerType = {
  [FIRST_ALERT]: 'warning',
  [SECOND_ALERT]: 'warning',
  [THIRD_ALERT]: 'error',
};

const iconColors = {
  [FIRST_ALERT]: 'rc-color-text-notice-on-notice-ultralight',
  [SECOND_ALERT]: 'rc-color-text-notice-on-notice-ultralight',
  [THIRD_ALERT]: 'rc-color-accent-urgent',
};

export function NegativeBalanceBanner({
  alertLevel,
}: Props) {
  return (
    <RCBanner
      title={I18n.t(`discovery.negativeBalances.${alertLevel}.headline`)}
      content={
        <Translate text={`discovery.negativeBalances.${alertLevel}.message`}>
          <a
            className="text-link"
            href={useHelpCenterArticleUrl(HELP_CENTER_ARTICLE_ID)}
            rel="noreferrer"
            target="_blank"
          >
            <Translate text="discovery.negativeBalances.learnMore"/>
          </a>
        </Translate>
      }
      image={
        <RCText color={iconColors[alertLevel]}>
          <RCIcon
            size="fullWidth"
            icon={<WarningIcon />}
          />
        </RCText>
      }
      theme={bannerType[alertLevel]}
      cta={<CoreLink to={URLHelpers.mySellingStatementsPath()}><Translate text="discovery.negativeBalances.updateBillingCard"/></CoreLink>}
    />
  );
}

export default NegativeBalanceBanner;
